import React, { createRef } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";

import { Grid, Dialog, IconButton } from "@material-ui/core";
import { Images } from "config/images";

const DialogSuccess = props => {
	const classes = useStyles();
	const { handleClose, open } = props;
	const nodeRef = createRef();

	return (
		<Dialog
			onClose={handleClose}
			aria-labelledby="customized-dialog-title"
			open={open}
			ref={nodeRef}
		>
			<Grid>
				<Grid classes={{ root: classes.closeButton }}>
					<IconButton aria-label="close" onClick={handleClose}>
						<CloseIcon />
					</IconButton>
				</Grid>
				<Grid classes={{ root: classes.body }}>
					<img
						src={Images.icGiftSuccess}
						alt={"icGiftSuccess"}
						width={72}
					/>
					<Grid classes={{ root: classes.title }}>
						Xác nhận tham gia chương trình thành công
					</Grid>
					<Grid container style={{ padding: 10 }}>
						<Grid
							item
							xs={12}
							classes={{
								root: classes.btnSubmit
							}}
							onClick={() => handleClose()}
						>
							Đóng
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Dialog>
	);
};

export default DialogSuccess;
